import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(4, 2)
  },
  image: {
    maxWidth: 180,
    width: '100%'
  },
  label: {
    marginTop: theme.spacing(2),
    textAlign: 'center'
  }
}))
